
import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";

import './form-item-home-services-vas.component.scss';

export class FormItemHomeServicesVas extends Base {

	applyForm: HTMLFormElement;
	successMessage: HTMLFormElement;
	errorMessage: HTMLFormElement;

	applyFormSubmit: Element[];

	movingDate: HTMLFormElement[];
	preferedMovingDate: HTMLFormElement;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.applyForm = this.element.querySelector('form') as HTMLFormElement;
		this.successMessage = this.applyForm.querySelector(".form__success--container");
		this.errorMessage = this.applyForm.querySelector(".form__serror--container");
		this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now-hs-vas__button'));

		this.movingDate = Array.from(this.applyForm.querySelectorAll("input[name=movingDateKnown]"));
		this.preferedMovingDate = this.applyForm.querySelector("input[name=preferredMovingDate]");

	}

	bindEvents() {
		this.applyFormSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.applyForm.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.applyForm.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.SubmitApplicationFormHomeServicesVas(this.applyForm, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

		if (this.movingDate) {
			this.movingDate.map(_radio => {
				_radio.addEventListener('change', (event: any) => {
					if (this.preferedMovingDate) {
						if (_radio.value == "NO") {
							this.preferedMovingDate.classList.remove("form__input--required");
						}
						else {
							this.preferedMovingDate.classList.add("form__input--required");
						}
					}
				});
			});
		}

		// Reset the form
		this.applyForm.addEventListener('custom_form_reset_event', (e) => {
			if (this.errorMessage) {
				this.errorMessage.classList.remove('active');
			}
			if (this.successMessage) {
				this.successMessage.classList.remove('active');
			}
		}, false);
	}

	SubmitApplicationFormHomeServicesVas(form: HTMLFormElement, loader: Element, thankyou: Element) {
		// additional containers
		let declined = form.querySelector('.form__declined--container');
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');
		let _actionName = form.querySelector("input[name=actionname]") as HTMLFormElement;

		// fields
		let _fields: any = {};
		for (let a = 0; a < form.length; a++) {
			const _field = form[a] as HTMLFormElement;
			_fields[_field.name] = _field.value;
		}

		_fields['reqVisitorId'] = this.analyticsService.getDtmVisitorID();

		const fields: any = 'actionname=' + _actionName.value + '&vasformJSONData=' + JSON.stringify(_fields);

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/homeservices/sbhsvasfoursure";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, fields, config).then((response: any) {
			let data = response.data;
			// service ok
			analyticsService.dtmFormComplete('complete', 'true');
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.add('hidden');
			fieldsContainer.classList.remove('active');
			thankyou.classList.remove('active');
			thankyou.classList.add('hidden');
			error.classList.add('active');
			error.classList.remove('active');
		});

	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-home-services-vas/form-item-home-services-vas.component.ts